import { TextareaAutosize } from '@material-ui/core';
import { COLORS } from 'components/twilio/constants';
import styled from 'styled-components';

const ChatTextArea = styled(TextareaAutosize)`
  font-family: Lato, sans-serif;
  background: rgba(255, 255, 255, 0.5);
  -webkit-appearance: none;
  resize: none;
  outline: none;
  color: ${COLORS.TEXT_DARK};
  border: 1px solid ${COLORS.GREY_H};
  padding: 7px 12px;
  border-radius: 15px;
  margin: 10px 4px;
  box-sizing: border-box;
  font-size: 16px;
  flex-grow: 1;
`;

export default ChatTextArea;
